export default {
  getJobListingCandidateTask: (state) => state.jobListingCandidateTask,
};
